import { Industry } from '@backrs_ui/common-ui';

import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '../baseQuery';
import { selectIsSharedSessionActive } from '../sharedSession/sharedSession';
import type { RootState } from '../store';

export const industryApi = createApi({
  reducerPath: 'industryApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (build) => ({
    getIndustryById: build.query<Industry, string>({
      queryFn: async (id, queryApi, _extraOptions, baseQuery): Promise<{ data: Industry }> => {
        const state = queryApi.getState() as RootState;
        const isSharedSession: boolean = selectIsSharedSessionActive(state);

        const url: string = isSharedSession
          ? `shared/solution-session/industries/${id}`
          : `industries/${id}`;

        return baseQuery({ url }) as Promise<{ data: Industry }>;
      },
      keepUnusedDataFor: 60 * 60 * 24,
    }),
    getAllIndustries: build.query<Industry[], undefined>({
      query: () => 'industries',
      keepUnusedDataFor: 60 * 60 * 24,
    }),
  }),
});

export const {
  useGetIndustryByIdQuery,
  useGetAllIndustriesQuery,
  usePrefetch: usePrefetchIndustry,
  util: { resetApiState },
} = industryApi;
